import type { PostInputMetaData } from '../../graphqlTypes'
import type { Draft } from '~publish/legacy/composer/composer/entities/Draft'
import { ensureUrlProtocol } from '~publish/legacy/composer/composer/utils/StringUtils'

import type { MapperContext } from '../../types'
import { clearable } from '../shared/clearable'
import type { ServiceMapperEntry } from '../types'

// Pinterest: the Pin's title (`draft.title`), destination link
// (`draft.sourceLink.url`, protocol-normalized like the legacy save path), and
// the board (`ctx.selectedBoardServiceId` — a per-profile selection, not a
// draft field). The Pin description is the shared top-level `text`;
// `channelData.pinterest` is display-only and never read here.
//
// `ctx.channelVariant` (when present) supplies `title`/`sourceLink`; the
// board selection stays ambient context regardless.
export function mapPinterest(
  draft: Draft,
  ctx: MapperContext,
): PostInputMetaData {
  const variant = ctx.channelVariant
  const title = variant ? variant.title : draft.title
  const url = variant ? variant.sourceLink?.url : draft.sourceLink?.url
  const boardServiceId = ctx.selectedBoardServiceId

  return {
    pinterest: {
      title: clearable(title, ctx),
      url: clearable(url != null ? ensureUrlProtocol(url) : url, ctx),
      // Deliberately not `clearable`: a Pin always needs a board, so clearing
      // makes no sense. With no selection the field is omitted on create (the
      // backend rejects the post with a typed error) and on edit (preserves
      // the stored board).
      ...(boardServiceId != null ? { boardServiceId } : {}),
    },
  }
}

export const pinterest: ServiceMapperEntry = {
  mapper: mapPinterest,
}
